var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"items":_vm.users,"disabled":_vm.isDisabled,"loading":_vm.isLoading,"label":"User"},on:{"input":_vm.onInput},model:{value:(_vm.user),callback:function ($$v) {_vm.user=$$v},expression:"user"}})}
var staticRenderFns = []

export { render, staticRenderFns }